export default __webpack_public_path__ + "static/media/mh.1dff1861.jpg";